import { string as yupString } from "yup";

/**
 * Same copy and rule as `yupString().email(...)` on offer contact forms
 * (e.g. Ting / Wind Defense `contact-information.tsx`).
 */
export const EMAIL_INVALID_MESSAGE = "Please enter a valid email address.";

/** Yup fragment for forms that should stay aligned with {@link isEmailFormatValid}. */
export const emailFormatYupString = () =>
  yupString().email(EMAIL_INVALID_MESSAGE);

/**
 * Sync format check using Yup’s `.email()` (no separate regex).
 * Empty / whitespace-only strings are invalid here; callers usually gate on `trim()` first.
 */
export function isEmailFormatValid(email: string): boolean {
  const t = email.trim();
  if (!t) {
    return false;
  }
  return yupString().email(EMAIL_INVALID_MESSAGE).isValidSync(t);
}
